import type { LucideIcon } from "lucide-react";
import type { IconType } from "react-icons";

interface CommentActionProps {
	label: string;
	icon: LucideIcon | IconType;
	onClick?: () => void;
}

const CommentAction = ({ label, icon: Icon, onClick }: CommentActionProps) => {
	return (
		<div key={label} data-tip={label} className="tooltip">
			<div
				key={label}
				onClick={onClick}
				className="max-h-max cursor-pointer hover:opacity-50"
			>
				<Icon size={16} />
			</div>
		</div>
	);
};

export default CommentAction;
